import { Api } from 'lib';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { EntitySettings, IrreversableModal } from 'screens/Admin/components';

const Settings = ({ post, closeModal }) => {
  const [visible, setVisible] = useState(null),
    [loading, setLoading] = useState(false),
    dispatch = useDispatch();

  async function handleFeature() {
    setLoading(true);

    const res = await Api.post('/admin/toggleFeatured', { postId: post._id });
    setLoading(false);
    if (!res) return;

    dispatch({
      type: 'HANDLE_RES',
      payload: { res: res.featured ? 'Added to featured.' : 'Removed from featured.' }
    });

    dispatch({
      type: 'ADMIN_EDIT_POST',
      payload: { _id: post._id, ...res }
    });
  }

  async function handleRemove() {
    setLoading(true);

    if (!post.isPost) {
      dispatch({
        type: 'HANDLE_RES',
        payload: { err: 'Unable to delete this post at this time.' }
      });
      return;
    }

    const res = await Api.post('/admin/removeData', { type: 'Post', id: post._id });

    setLoading(false);
    if (!res) return;

    closeModal();
  }

  if (!post) return null;

  const settings = [
    {
      text: post.featured ? 'Remove from featured' : 'Show as featured',
      icon: post.featured ? 'starFilled' : 'starOutline',
      onClick: () => setVisible('feature'),
      isDisabled: loading
    },
    {
      text: 'Remove post',
      icon: 'delete',
      onClick: () => setVisible('remove'),
      isDisabled: loading
    }
  ];

  return (
    <React.Fragment>
      <EntitySettings options={settings} />

      <IrreversableModal
        visible={visible === 'feature'}
        heading={
          post.featured
            ? 'This post will no longer show top of the home screen.'
            : 'This post will be showing top of the home screen.'
        }
        text="Continue?"
        onConfirm={handleFeature}
        closeModal={() => setVisible(null)}
      />

      <IrreversableModal
        visible={visible === 'remove'}
        heading="You are about to remove this post."
        onConfirm={handleRemove}
        closeModal={() => setVisible(null)}
      />
    </React.Fragment>
  );
};

export default Settings;
